import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VisaTypeService {
  private apiUrl = `${environment.apiUrl}/visaType`;

  constructor(private http: HttpClient) {}

  // Get list of Visa Types
  getList(): Observable<any> {
    const herader = {
      skipLoad: 'true',
    }
    return this.http.get<any>(this.apiUrl,{headers: herader});
  }

// get by countryId and visitReasonId
getByCountryId(countryId: number, visitReasonId: number): Observable<any> {
  const headers = {
    skipLoad: 'true',
  };
  return this.http.get<any>(`${this.apiUrl}/${countryId}/${visitReasonId}`, { headers: headers });
}



}
